import React from 'react';
import useSendProfileToCompany from '../../../../hooks/useSendProfileToCompany'; 
import './profileCompanyHeader.css'
import {useAuth} from '../../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import useSignedImage from '../../../../hooks/useSignedImage';

const ProfileCompanyHeader = ({ id, data, offersRef }) => {
  const { isLoading, error, successMessage, isCvSent, createTalentPoolRecord } = useSendProfileToCompany(id);
  const navigate = useNavigate();
  const { isAuthenticated, userInfo, logout } = useAuth();
 
  const handleSendProfile = async () => {
    if (!isAuthenticated) {
      navigate('/profesionales/entrar')
      return; 
    }

    try {
      createTalentPoolRecord();
    } catch (error) {
      console.error('Error sending profile:', error.message);
    }
  };

  const handleScrollToOffers = () => {
    if (offersRef?.current) {
      offersRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const companyName = data?.name || 'Dummy Company Name';
  const companyFormat = data?.format || 'Dummy Format';
  const profileImage = data?.profileImageUrl;
  
  // Use the signed image hook to handle Wasabi URLs
  const { imageUrl: signedImageUrl, isLoading: imageLoading, error: imageError } = useSignedImage(profileImage, '/default-restaurant.png');
  
  return (
    <div className="profile-company-header__container">
      <div className="profile-company-header__background-container">
   
      </div>
      <div className="profile-company-header__image-info-container ">
        <div className="profile-company-header__avatar-container">
          <img 
            id="profile-company-header__img" 
            className="profile-company-header_profile-image" 
            src={signedImageUrl} 
            alt="Avatar" 
            onError={(e) => {
              console.error('❌ ProfileCompanyHeader: Image failed to load, using fallback');
              e.target.src = '/default-restaurant.png';
            }}
          />
        </div>
        <div className="profile-company-header__info-container">
          <div className="profile-company-header__text-info">
            <h1 className="profile-company-header__name">{companyName}</h1>
            <h2 className="profile-company-header__company">{companyFormat}</h2>
           
          </div>
          <div className="profile-company-header__buttons">
            <button onClick={handleScrollToOffers} className="profile-company-header__button">Ofertas</button>
            <button onClick={handleSendProfile} className="profile-company-header__button" disabled={isCvSent}>
              {isCvSent ? 'Enviado' : 'Enviar CV'}
            </button>
          </div>
        </div>  
      </div>
    </div>
  );
};

export default ProfileCompanyHeader;